// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export default async function logService(logInput) {

  // Format Mutation
  const query = `mutation logService($log: NewLogInput) { logService (log: $log) 
    { 
      level
      message
      className
      methodName
     } }`;

  // Variables
  const variables = {
    log: logInput,
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
    authCheck: false,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/graphql/logging.js